import { http } from '@/libs/util'
import util from '@/libs/util'
const { 
    fin_receipt_bill_transform_to_accrual
 } = util.api || {}


 export function generateFinReceiptBillTransform2AccrualApi(params) {
     return http.post(fin_receipt_bill_transform_to_accrual, params)
 }